async function fetchAuthorProfile() {
    let id = localStorage.getItem("id");
    let ref = localStorage.getItem("ref");
    let authorProfile;

    let headers = { "Content-Type": "application/json" };
    if (typeof site !== 'undefined' && site !== '') {
        headers.site = site;
    }

    if (typeof ghostMemberId !== 'undefined' && ghostMemberId) {
        headers.ghostMemberId = ghostMemberId;
    } else if (id) {
        headers.contactId = id;
    } else if (ref) {
        headers.ref = ref;
    } 

    if (document.querySelector('body.post-template') || document.querySelector('.gh-container.gh-author-page')) {
        headers.about = 'true';
    }

    try {
        const baseUrl = typeof cmsUrl !== 'undefined' ? cmsUrl : "https://cms.breakingbank.media";
        const res = await fetch(baseUrl + "/api/author-info", {
            method: "GET",
            headers: headers
        });
        authorProfile = await res.json();
        if (!authorProfile?.author) return;
    } catch (error) {
        console.error("Error fetching author info:", error);
        return;
    }

    const baseUrl = typeof cmsUrl !== 'undefined' ? cmsUrl : "https://cms.breakingbank.media";

    if (authorProfile.name) {
        // Post card author links/text overrides
        document.querySelectorAll('.gh-card-author').forEach((element) => {
            authorProfile.override.forEach((item) => {
                if (element.textContent.includes(item.name)) {
                    element.innerHTML = element.innerHTML.replace(
                        item.name, 
                        `<a href="https://breakingbank.media/author/${authorProfile.slug}">${authorProfile.name}</a>`
                    );
                }
            });
        });

        // Header author links/text overrides in post template
        document.querySelectorAll('.gh-article-author-name a').forEach((element) => {
            if (authorProfile.override.some(item => item.name === element.textContent.trim())) {
                element.textContent = authorProfile.name;
                element.href = 'https://breakingbank.media/author/' + authorProfile.slug;
            }
        });

        // Header author profile images in post template
        document.querySelectorAll('.gh-article-author-image a').forEach((element) => {
            const img = element.querySelector('img');
            if (img && authorProfile.override.some(item => item.name === img.alt.trim())) {
                element.href = 'https://breakingbank.media/author/' + authorProfile.slug;
                if (authorProfile.profilePicture) {
                    img.src = baseUrl + authorProfile.profilePicture;
                }
                img.alt = authorProfile.name;
            }
        });

        // Additional slider/featured list author name overrides if present
        document.querySelectorAll('.gh-medium-slider-slide-author').forEach((element) => {
            if (authorProfile.override.some(item => item.name === element.textContent.trim())) {
                element.textContent = authorProfile.name;
                element.href = 'https://breakingbank.media/author/' + authorProfile.slug;
            }
        });
        document.querySelectorAll('.gh-sidebar-feat-post-author').forEach((element) => {
            if (authorProfile.override.some(item => item.name === element.textContent.trim())) {
                element.textContent = authorProfile.name;
                element.href = 'https://breakingbank.media/author/' + authorProfile.slug;
            }
        });
    }

    if (authorProfile.logo) {
        document.querySelectorAll('.gh-site-logo img').forEach((element) => {
            element.src = baseUrl + authorProfile.logo;
            element.style.height = authorProfile.logoHeight || '';
        });
    }

    if (document.querySelector('body.post-template')) {
        if (typeof authors !== 'undefined' && authorProfile.override.some(item => authors.includes(item.slug))) {
            renderAuthorSection(authorProfile, baseUrl); 
        }
    }
}

function renderAuthorSection(authorData, baseUrl) {
    const container = document.querySelector('.post-template .about-author-section');
    
    if (!container) {
        console.error('Author section container not found');
        return;
    }
    
    const authorHTML = `
    <h2 class="text-2xl font-bold mb-6 text-white">About the Author</h2>
  
    <div class="author-container flex flex-col md:flex-row items-start gap-6">
        <!-- Author Profile Image -->
        ${authorData.profilePicture ? `<div class="author-image flex-shrink-0">
            <img src="${baseUrl + authorData.profilePicture}" alt="${authorData.name || 'Author'}"
                class="w-24 h-24 rounded-full object-cover border-2 border-gray-700" />
        </div>` : ''}
  
        <!-- Author Info -->
        <div class="author-info">
            <h2 class="text-xl font-bold text-white mb-2">${authorData.name || 'Team Breaking Bank'}</h2>
  
            <div class="text-gray-300 mb-4 content">
                ${authorData.about || 'The Breaking Bank team consists of financial experts, mortgage specialists, and real estate professionals with over 20 years of combined experience in the industry.'}
            </div>
  
            <div class="author-social flex gap-3">
                ${authorData.socialLinks?.twitter ? `
                    <a href="https://x.com/${authorData.socialLinks.twitter}" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M24 4.557c-.883.392-1.832.656-2.828.775 1.017-.609 1.798-1.574 2.165-2.724-.951.564-2.005.974-3.127 1.195-.897-.957-2.178-1.555-3.594-1.555-3.179 0-5.515 2.966-4.797 6.045-4.091-.205-7.719-2.165-10.148-5.144-1.29 2.213-.669 5.108 1.523 6.574-.806-.026-1.566-.247-2.229-.616-.054 2.281 1.581 4.415 3.949 4.89-.693.188-1.452.232-2.224.084.626 1.956 2.444 3.379 4.6 3.419-2.07 1.623-4.678 2.348-7.29 2.04 2.179 1.397 4.768 2.212 7.548 2.212 9.142 0 14.307-7.721 13.995-14.646.962-.695 1.797-1.562 2.457-2.549z" />
                        </svg>
                    </a>` : ''}
  
                ${authorData.socialLinks?.facebook ? `
                    <a href="https://www.facebook.com/${authorData.socialLinks.facebook}" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M9 8h-3v4h3v12h5v-12h3.642l.358-4h-4v-1.667c0-.955.192-1.333 1.115-1.333h2.885v-5h-3.808c-3.596 0-5.192 1.583-5.192 4.615v3.385z" />
                        </svg>
                    </a>` : ''}
                          
                ${authorData.socialLinks?.linkedin ? `
                    <a href="https://www.linkedin.com/in/${authorData.socialLinks.linkedin}" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 16h-2v-6h2v6zm-1-6.891c-.607 0-1.1-.496-1.1-1.109 0-.612.492-1.109 1.1-1.109s1.1.497 1.1 1.109c0 .613-.493 1.109-1.1 1.109zm8 6.891h-1.998v-2.861c0-1.881-2.002-1.722-2.002 0v2.861h-2v-6h2v1.093c.872-1.616 4-1.736 4 1.548v3.359z" />
                        </svg>
                    </a>` : ''}
 
                ${authorData.socialLinks?.instagram ? `
                    <a href="https://www.instagram.com/${authorData.socialLinks.instagram}" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                            <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204 0.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                        </svg>
                    </a>` : ''}
 
                ${authorData.socialLinks?.threads ? `
                    <a href="https://www.threads.net/${authorData.socialLinks.threads}" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="32" width="32"><path d="M64 32C28.7 32 0 60.7 0 96V416c0 35.3 28.7 64 64 64H384c35.3 0 64-28.7 64-64V96c0-35.3-28.7-64-64-64H64zM294.2 244.3c19.5 9.3 33.7 23.5 41.2 40.9c10.4 24.3 11.4 63.9-20.2 95.4c-24.2 24.1-53.5 35-95.1 35.3h-.2c-46.8-.3-82.8-16.1-106.9-46.8C91.5 341.8 80.4 303.7 80 256v-.1-.1c.4-47.7 11.5-85.7 33-113.1c24.2-30.7 60.2-46.5 106.9-46.8h.2c46.9 .3 83.3 16 108.2 46.6c12.3 15.1 21.3 33.3 27 54.4l-26.9 7.2c-4.7-17.2-11.9-31.9-21.4-43.6c-19.4-23.9-48.7-36.1-87-36.4c-38 .3-66.8 12.5-85.5 36.2c-17.5 22.3-26.6 54.4-26.9 95.5c.3 41.1 9.4 73.3 26.9 95.5c18.7 23.8 47.4 36 85.5 36.2c34.3-.3 56.9-8.4 75.8-27.3c21.5-21.5 21.1-47.9 14.2-64c-4-9.4-11.4-17.3-21.3-23.3c-2.4 18-7.9 32.2-16.5 43.2c-11.4 14.5-27.7 22.4-48.4 23.5c-15.7 .9-30.8-2.9-42.6-10.7c-13.9-9.2-22-23.2-22.9-39.5c-1.7-32.2 23.8-55.3 63.5-57.6c14.1-.8 27.3-.2 39.5 1.9c-1.6-9.9-4.9-17.7-9.8-23.4c-6.7-7.8-17.1-11.8-30.8-11.9h-.4c-11 0-26 3.1-35.6 17.6l-23-15.8c12.8-19.4 33.6-30.1 58.5-30.1h.6c41.8 .3 66.6 26.3 69.1 71.8c1.4 .6 2.8 1.2 4.2 1.9l.1 .5zm-71.8 67.5c17-.9 36.4-7.6 39.7-48.8c-8.8-1.9-18.6-2.9-29-2.9c-3.2 0-6.4 .1-9.6 .3c-28.6 1.6-38.1 15.5-37.4 27.9c.9 16.7 19 24.5 36.4 23.6l-.1-.1z"/></svg>
                    </a>` : ''}
 
                ${authorData.socialLinks?.bluesky ? `
                    <a href="https://bsky.app/profile/${authorData.socialLinks.bluesky}" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" height="32" width="32"><path d="M111.8 62.2C170.2 105.9 233 194.7 256 242.4c23-47.6 85.8-136.4 144.2-180.2c42.1-31.6 110.3-56 110.3 21.8c0 15.5-8.9 130.5-14.1 149.2C478.2 298 412 314.6 353.1 304.5c102.9 17.5 129.1 75.5 72.5 133.5c-107.4 110.2-154.3-27.6-166.3-62.9l0 0c-1.7-4.9-2.6-7.8-3.3-7.8s-1.6 3-3.3 7.8l0 0c-12 35.3-59 173.1-166.3 62.9c-56.5-58-30.4-116 72.5-133.5C100 314.6 33.8 298 15.7 233.1C10.4 214.4 1.5 99.4 1.5 83.9c0-77.8 68.2-53.4 110.3-21.8z"/></svg>
                    </a>` : ''}
 
                ${authorData.socialLinks?.mastodon ? `
                    <a href="https://${authorData.socialLinks.mastodon}" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors">
                        <svg height="32" width="32" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M433 179.1c0-97.2-63.7-125.7-63.7-125.7-62.5-28.7-228.6-28.4-290.5 0 0 0-63.7 28.5-63.7 125.7 0 115.7-6.6 259.4 105.6 289.1 40.5 10.7 75.3 13 103.3 11.4 50.8-2.8 79.3-18.1 79.3-18.1l-1.7-36.9s-36.3 11.4-77.1 10.1c-40.4-1.4-83-4.4-89.6-54a102.5 102.5 0 0 1 -.9-13.9c85.6 20.9 158.7 9.1 178.8 6.7 56.1-6.7 105-41.3 111.2-72.9 9.8-49.8 9-121.5 9-121.5zm-75.1 125.2h-46.6v-114.2c0-49.7-64-51.6-64 6.9v62.5h-46.3V197c0-58.5-64-56.6-64-6.9v114.2H90.2c0-122.1-5.2-147.9 18.4-175 25.9-28.9 79.8-30.8 103.8 6.1l11.6 19.5 11.6-19.5c24.1-37.1 78.1-34.8 103.8-6.1 23.7 27.3 18.4 53 18.4 175z"/></svg>
                    </a>` : ''}
 
                ${authorData.socialLinks?.tiktok ? `
                    <a href="https://www.tiktok.com/${authorData.socialLinks.tiktok}" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" height="32" width="32"><path d="M448 209.9a210.1 210.1 0 0 1 -122.8-39.3V349.4A162.6 162.6 0 1 1 185 188.3V278.2a74.6 74.6 0 1 0 52.2 71.2V0l88 0a121.2 121.2 0 0 0 1.9 22.2h0A122.2 122.2 0 0 0 381 102.4a121.4 121.4 0 0 0 67 20.1z"/></svg>
                    </a>` : ''}
 
                ${authorData.socialLinks?.youtube ? `
                    <a href="https://www.youtube.com/${authorData.socialLinks.youtube}" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" height="32" width="32"><path d="M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6-11.4 42.9-11.4 132.3-11.4 132.3s0 89.4 11.4 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.2 48.3-47.8 11.4-42.9 11.4-132.3 11.4-132.3s0-89.4-11.4-132.3zm-317.5 213.5V175.2l142.7 81.2-142.7 81.2z"/></svg>
                    </a>` : ''}
  
                ${authorData.socialLinks?.website ? `
                    <a href="${authorData.socialLinks.website}" target="_blank" rel="noopener noreferrer" class="text-gray-400 hover:text-white transition-colors website-svg">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="h-5 w-5">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="2" y1="12" x2="22" y2="12"></line>
                            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                        </svg>
                    </a>` : ''}
            </div>
        </div>
    </div>
    `;
    
    container.innerHTML = authorHTML;
    container.style.display = 'block';
}
